// extracted by mini-css-extract-plugin
export default {"container":"VendorDetails_container__93A7F","details":"VendorDetails_details__bl9fh","contact":"VendorDetails_contact__ynkb7","title":"VendorDetails_title__A+QSP"};